import React, { useContext, useEffect } from 'react';
import htmlParse from 'react-html-parser';
import AppContext from '../../../contexts/AppContext';
import { gsap, Power1 } from 'gsap';
import './IntroLayer.css';

export default function IntroDescr({ loadedGallery }) {
  const { dictionnary } = useContext(AppContext);

  const animate = () => {
    const t = 0.5;

    gsap.to(['.animated-intro-wrapper-0'], {
      opacity: 1,
      duration: t,
      ease: Power1.easeInOut,
      delay: 0,
    });
    gsap.to(['.animated-intro-wrapper-1'], {
      opacity: 1,
      duration: t,
      ease: Power1.easeInOut,
      delay: t * 0.25,
    });
    gsap.to(['.animated-intro-wrapper-2'], {
      opacity: 1,
      duration: t,
      ease: Power1.easeInOut,
      delay: t * 2 * 0.25,
    });

    // tl.from("#lower", { duration: 0.75, y: -30 }, "text");
  };

  useEffect(() => {
    // Update the document title using the browser API
    animate();
  });

  const subtitleClass = 'intro-subtitle-small';

  return (
    <div>
      <div
        id="intro-logo-title"
        className={'animated-intro-wrapper-0 animated-intro-wrapper'}
      >
        {htmlParse(dictionnary.get('intro-descr-title'))}
      </div>
      <div
        id={subtitleClass}
        className={'animated-intro-wrapper-1 animated-intro-wrapper'}
      >
        {htmlParse(dictionnary.get('intro-descr-content'))}
      </div>
    </div>
  );
}
